import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'
import { loadAnalyticsIfConsented } from './lib/consent'

// Initialize Sentry before app renders (production only)
initSentry()

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Enable Vercel Web Analytics only if user has consented (production only)
// The CookieConsent component handles loading analytics when user accepts
if (import.meta.env.PROD) {
  loadAnalyticsIfConsented()
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element missing in index.html')
}

const root = createRoot(rootElement)

if (!clerkPublishableKey) {
  console.warn('Missing VITE_CLERK_PUBLISHABLE_KEY – Clerk will not initialize.')
  root.render(
    <BrowserRouter>
      <main className="min-h-screen w-full bg-slate-50 text-slate-900">
        <section className="mx-auto flex h-screen max-w-xl flex-col items-center justify-center gap-4 px-4 text-center">
          <h1 className="text-2xl font-semibold">Clerk configuration required</h1>
          <p className="text-sm text-slate-600">
            Add <code>VITE_CLERK_PUBLISHABLE_KEY</code> to your environment and restart the dev server to
            enable authentication features.
          </p>
        </section>
      </main>
    </BrowserRouter>
  )
} else {
  root.render(
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  )
}
